import React from 'react';
import Offer from './Offer';
import { useContext, useState } from 'react';
import SimpleContext from './../../context/SimpleContext';
import { Modal } from 'react-bootstrap';
import SabadKharidDrawer from './../../products/SabadKharidDrawer/SabadKharidDrawer';
import { Button } from 'react-bootstrap';

const Offers = () => {

    const context = useContext(SimpleContext);
    const [modalShow, setModalShow] = useState(false); 


    return (  

        <div className='products'>
            <div className="otherPagesHeader">
                <div onClick={context.drawerToggleClickHandler} className="barbuttonn">
                    <i className="fa fa-bars" />
                </div>
                <div className="headersNames">
                    <h6>محصولات</h6>
                </div>
                <div className="searchbtnn">
                    <i className="fa fa-filter" onClick={()=>setModalShow(true)}/>
                </div>
            </div>
            <div className="productHolder">
                {
                    context.Offers.length ? 
                    context.Offers.map((product,i) =>
                        <div key={i}>
                            <Offer
                            key={product.id}
                            name = {product.name}
                            price = {product.price}
                            userPrice = {product.user_price}
                            slug = {product.slug}
                            min = {product.minimum}
                            max = {product.maximum}
                            proid = {product.brandID}
                            isSahmiyeh = {product.sahmie_bandi}
                            isvalid = {product.status}
                            numUnit = {product.number_in_unit}
                            numSale = {product.number_in_sale}
                            unit = {product.unit}
                            stock={product.stock}
                            category={product.category}
                            ulImg={product.ULImg}
                            dlImg={product.DLImg}
                            urImg={product.URImg}
                            drImg={product.DRImg}
                            mojud={product.FreshStatus}
                            /> 
                        
                        </div>
                    ):null
                }
            </div>
            <Modal
            show={modalShow}
            centered>
                <Modal.Header style={{width:"100%", backgroundColor:"#fb7a36"}} className="text-center p-3">
                    <p style={{margin:"0", color:"#fff", fontSize:"17px", textAlign:"center", marginRight:"38%"}}>
                    فیلتر کالاها
                    </p>
                </Modal.Header>
                <Modal.Body style={{padding:"2%",display: "flex", flexDirection: "column",justifyContent: "center",alignItems: "center"}}>

                    <p>فقط موجود <input type="radio" id="radio_1"/></p>
                    <p> کالاهای پرگردش <input type="radio" id="radio_1"/></p>

                </Modal.Body>
                <Modal.Footer style={{padding:"3%"}}>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setModalShow(false)}>فیلتر کن</Button>
                </Modal.Footer>
                </Modal>

            <div className="SabadDrawer" >
                <SabadKharidDrawer/>
            </div>
        </div>
    );
}
 
export default Offers;